import { AIRPORTS } from '../data/airports';

/**
 * Search airports with scored ranking.
 * @param {string} query - Search term (IATA code, city, airport name, or country)
 * @returns {Array} Top 20 matching airports sorted by relevance score
 */
export function searchAirports(query) {
  if (!query || !query.trim()) return [];

  const q = query.trim().toLowerCase();
  const scored = [];

  for (let i = 0; i < AIRPORTS.length; i++) {
    const a = AIRPORTS[i];
    const iata = a.iata.toLowerCase();
    const city = a.city.toLowerCase();
    const name = a.name.toLowerCase();
    const country = a.country.toLowerCase();

    let score = 0;

    if (iata === q) {
      score = 100;
    } else if (iata.startsWith(q)) {
      score = 80;
    } else if (city.startsWith(q)) {
      score = 70;
    } else if (city.includes(q) || name.includes(q)) {
      score = 50;
    } else if (country.includes(q)) {
      score = 30;
    }

    if (score > 0) {
      scored.push({ ...a, _score: score });
    }
  }

  scored.sort((a, b) => b._score - a._score || a.city.localeCompare(b.city));

  return scored.slice(0, 20).map(({ _score, ...airport }) => airport);
}
